import { render, staticRenderFns } from "./festivos-avisos.vue?vue&type=template&id=1419e222&scoped=true"
import script from "./festivos-avisos.vue?vue&type=script&lang=js"
export * from "./festivos-avisos.vue?vue&type=script&lang=js"
import style0 from "./festivos-avisos.vue?vue&type=style&index=0&id=1419e222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1419e222",
  null
  
)

export default component.exports